// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const projectInfo = {
    "name": "elab-spa",
    "version": "1.14.0",
    "commitHash": "dc930de3130b97bf14262d74f47357830620e8b9",
    "gitBuildDate": "2026-10-28 14:04:22 +0000"
};
/* tslint:enable */
